<script setup lang="ts">
  import { Badge } from '@ui/components/badge';

  interface Props {
    name: string;
  }

  defineProps<Props>();
</script>

<template>
  <Badge variant="agent" size="sm">
    {{ name }}
  </Badge>
</template>
